import Facets from 'components/search/Facets';
import { FacetsSidebar } from 'components/search/Facets/FacetsSidebar';
import { FEATURE_SEARCH_FACETS_UPDATE } from 'constants/features';
import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';
import type { FacetsDataType } from 'types/search';

type FacetsManagerProps = React.ComponentProps<typeof Facets> & {
  facetsV2: FacetsDataType;
};

export const FacetsManager = (props: FacetsManagerProps) => {
  const { isEnrolled: isSearchFacetUpdate } = useIsEnrolledInVariant(FEATURE_SEARCH_FACETS_UPDATE);

  if (isSearchFacetUpdate) {
    // Use navigationV2 facet experience
    return <FacetsSidebar />;
  }

  // Use existing facet experience with autofacet support
  return (
    <Facets
      {...props}
      facets={props.facets}
      breadcrumbs={props.breadcrumbs}
      autofacetState={props.autofacetState}
      removeAutofacetFilter={props.removeAutofacetFilter}
    />
  );
};
